<template>
  <div>
    <iframe
      :src="mapSrc"
      :width="width"
      :height="height"
      style="border:0;"
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade">
    </iframe>
  </div>
</template>

<script>
import { getConfigDataFromLocalStorage } from '@/localStorageData/localStorageUtil.js';
export default {
     props: {
    width: {
      type: [String, Number],
      default: '600'
    },
    height: {
      type: [String, Number],
      default: '450'
    }
  },
  data() {
    return {
      address: '',
      address1:'',
      mapSrc: ''
    }
  },
  methods: {
    getConfig(){
        const getConfigData = getConfigDataFromLocalStorage();
        if(getConfigData){
            this.address = getConfigData.payload.portal_configuration.portal_footer_address1;
            this.address1 = getConfigData.payload.portal_configuration.portal_footer_address2;
            this.updateMap()
        }
    },
    updateMap() {
        let fullAddress = `${this.address}, ${this.address1}`
      const encodedAddress = encodeURIComponent(fullAddress);
      console.log(encodedAddress,'encodedAddress')
      this.mapSrc = `https://maps.google.com/maps?q=${encodedAddress}&output=embed`;
    }
  },
  created(){
    this.getConfig();
  }
}
</script>
